import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { State as MenuState } from '../redux/reducers';
import * as rootReducers from '../redux/reducers';

@Injectable()
export class PermissionGuard implements CanActivate {
  private state$: Observable<MenuState>;

  constructor(private readonly store: Store<any>) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    this.state$ = this.store.pipe(select(rootReducers.getMenuListState));

    return this.state$.pipe(
      take(1),
      map(state => this.checkAccess(route.url[0].path, state['menuList']))
    );
  }

  checkAccess(url, routes) {
    return (
      this.checkAccessGeneric(url, routes.left) ||
      this.checkAccessGeneric(url, routes.bottom) ||
      this.checkAccessGeneric(url, routes.main)
    );
  }

  checkAccessGeneric(url, direct) {
    if (direct && direct.length) {
      for (const ele of direct) {
        if (ele.code === url) {
          return true;
        }
      }
    }
    return false;
  }
}
